import { defineStore } from "pinia";

export const useEvaluationPhaseStore = defineStore('evaluationPhase', {
    state: () => ({
        evaluationPhase: {},
        evaluationPhases: [],
    }),
    actions: {
        setEvaluationPhase(evaluationPhase) {
            this.evaluationPhase = evaluationPhase
        },
        setEvaluationPhases(evaluationPhases) {
            this.evaluationPhases = evaluationPhases;
        },
        addEvaluationPhase(evaluationPhase) {
            this.evaluationPhases.unshift(evaluationPhase)
        },
        updateEvaluationPhase(evaluationPhase) {
            let index = this.evaluationPhases.findIndex(cl => cl.id === evaluationPhase.id)
            this.evaluationPhases.splice(index, 1, evaluationPhase)
        },
        deleteEvaluationPhase(evaluationPhase) {
            let index = this.evaluationPhases.findIndex(cl => cl.id === evaluationPhase.id)
            this.evaluationPhases.splice(index, 1)
        },
    },
});